import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b5a92e8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6b5a92e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSlider: require('/opt/build/repo/components/Elements/Slider.vue').default,IconsCloseBtn: require('/opt/build/repo/components/Icons/CloseBtn.vue').default,ModulesCommonNuxtImage: require('/opt/build/repo/components/Modules/Common/NuxtImage/index.vue').default})
